import {FC, useState, createContext, useContext} from 'react'
import {WithChildren} from '../../../_metronic/helpers'
import {TFranchiseResponse} from '../../../coreGlobal/models/franchise/franchise'
import {getFranchiseById} from './_request'
import {ContactRequest, IPersonResponse} from '../../../coreGlobal/models/person'

interface IFormContext {
  franchise: TFranchiseResponse | undefined
  setFranchise: React.Dispatch<React.SetStateAction<TFranchiseResponse | undefined>>
  getDataFranchise: (id: string) => void

  contacts: ContactRequest[]
  setContacts: React.Dispatch<React.SetStateAction<ContactRequest[]>>

  fieldContacts: ContactRequest[]
  setFieldContacts: React.Dispatch<React.SetStateAction<ContactRequest[]>>

  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const FranshiseContext = createContext<IFormContext>({} as IFormContext)

const FranchiseProvider: FC<WithChildren> = ({children}) => {
  const [franchise, setFranchise] = useState<TFranchiseResponse>()

  const [contacts, setContacts] = useState<ContactRequest[]>([
    {type: 1, phone: '', countryId: 76, phoneCode: 55},
  ])
  const [fieldContacts, setFieldContacts] = useState<ContactRequest[]>([
    {type: 1, phone: '', countryId: 76, phoneCode: 55},
  ])

  const [loading, setLoading] = useState(false)

  const getDataFranchise = async (id: string) => {
    const data = await getFranchiseById(id)
    setFranchise(data)
  }

  return (
    <FranshiseContext.Provider
      value={{
        franchise,
        setFranchise,
        getDataFranchise,

        contacts,
        setContacts,
        fieldContacts,
        setFieldContacts,

        loading,
        setLoading,
      }}
    >
      {children}
    </FranshiseContext.Provider>
  )
}

const useFormFranchise = () => useContext(FranshiseContext)

export {FranchiseProvider, useFormFranchise}
